import { SchoolData } from "@nimble/candidate-api/types";
import Link from "next/link";
import { AnchorHTMLAttributes } from "react";

import routes from "@/lib/routes";
import { StateConfig } from "@/lib/states-config";

export enum SchoolLinkTarget {
  SameTab = "same_tab",
  NewTab = "new_tab",
}

const linkTargetAttributes: Record<
  SchoolLinkTarget,
  Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "target" | "rel">
> = {
  [SchoolLinkTarget.SameTab]: {},
  [SchoolLinkTarget.NewTab]: { target: "_blank", rel: "noopener noreferrer" },
};

export default function SchoolNameLink({
  schoolData,
  stateConfig,
  schoolLinkTarget,
}: {
  schoolData: SchoolData;
  stateConfig: StateConfig;
  schoolLinkTarget: SchoolLinkTarget;
}) {
  return (
    <Link
      href={routes.getSchool({
        state: stateConfig,
        districtId: schoolData.district.nces_id,
        schoolId: schoolData.nces_id,
      })}
      className="cursor-pointer text-inherit hover:text-primary transition-colors"
      {...linkTargetAttributes[schoolLinkTarget]}
    >
      {schoolData.name}
    </Link>
  );
}
